import type { LocaleRouteDefinition } from './locale-route-definition'
import type { RouteKind } from '../route-kind'

export interface PagesRouteDefinition
  extends LocaleRouteDefinition<RouteKind.PAGES> {}
